import { render, staticRenderFns } from "./backto-top.vue?vue&type=template&id=ebb03a34&scoped=true&lang=pug&"
import script from "./backto-top.vue?vue&type=script&lang=js&"
export * from "./backto-top.vue?vue&type=script&lang=js&"
import style0 from "./backto-top.vue?vue&type=style&index=0&id=ebb03a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb03a34",
  null
  
)

export default component.exports